import axios from 'axios';

const AuthService = {

    // Este metodo lo que hace es configurar como "plugin global" a las instancias 
    // de vue que se esten utilizando.
    install(Vue, options) {

        /*
            options: {
                router: {} // el router para hacer las redireccioens y demas
                store: {}, 
                sessionStorage: bool // si esta en true, guarda en el sessionstorage en vez del local
                localStorageAuthInfo
                statusApi: '' // url de la api para checkear el status del token
                baseApi: '', // esta es la base url de la API
                loginApi: '', // login o authorize
                logoutApi: '',  // logout o revoke-token
                refreshApi: '', // la ruta del refresh-token
                loginRoute: '', // la ruta del login,
                logoutRoute: '', // la ruta del logout,
                defaultRoute: '', // ruta del front a la que redirecciona cuando loguea
                userInfo: '',     // la ruta del get user info (digamos la del perfil mas roles)

            }
        */

        // configuracion inicial  
        // ------------------------

        // sin o esta declarado el nombre del contenedor de authinfo, se lo agrega por default
        if (!options.localStorageAuthInfo) {
            options.localStorageAuthInfo = 'authInfo';
        }


        // funciones para manipular token y auth info 
        // ----------------------------------------------

        function getAuthInfo() {
            if (options.sessionStorage === true)
                return JSON.parse(sessionStorage.getItem(options.localStorageAuthInfo));
            else
                return JSON.parse(localStorage.getItem(options.localStorageAuthInfo));
        }

        function setAuthInfo(authInfo) {
            if (options.sessionStorage === true)
                sessionStorage.setItem(options.localStorageAuthInfo, JSON.stringify(authInfo));
            else
                localStorage.setItem(options.localStorageAuthInfo, JSON.stringify(authInfo));
        }

        function deleteAuthInfo() {
            // borra el storage de la info de auth
            if (options.sessionStorage === true)
                sessionStorage.clear();
            else
                localStorage.clear();

            // borra la cookie
        }

        // funciones para configurar la validacion de las rutas con guard
        // ----------------------------------------------------------------

        function configureRouter() {

            /**
             * Este metodo lo que hace es que antes (before) de cada llamada
             * al router, verifica si tiene restriccion de autenticacion, 
             * si es asi, verifica si existe o no token, y si no, redirecciona
             */
            options.router.beforeEach(async (to, from, next) => {

                // if (!to.matched.length) {
                //     next(options.defaultRoute);
                // }

                if (to.meta.auth === true) {

                    /**
                     * Si la ruta tiene la restriccion de auth,
                     * y esta es igual a true, solamente verifica que
                     * el token exista. Si no es asi, redirecciona a login
                     */
                    const authInfo = getAuthInfo();

                    if (!authInfo || !authInfo.token || !authInfo.id) {

                        //si no esta autenticado, intenta el refresh
                        if (await getRefreshToken()) {
                            // si logra refrescar, continua con la peticion
                            next();
                        } else {
                            // si no logra refrescar, lo manda al login nuevamente
                            deleteAuthInfo();
                            next(options.loginRoute);
                        }

                    } else {
                        //si està autenticado, continua con la peticion
                        next();
                    }
                } else if (to.meta.auth === false) {

                    /**
                     * Si la restriccion de auth esta en false,
                     * quiere decir que la pagina es solo
                     * accesible si NO se esta autenticado,
                     * entonces, si YA esta autenticado, redirecciona a
                     * la pagina por default
                     */
                    const authInfo = getAuthInfo();

                    if (authInfo) {
                        next(options.defaultRoute);
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            })
        }

        async function getRefreshToken() {

            // 1. verifica que exista la opcion de refresh token
            if (!options.refreshToken)
                return false;

            // 2. obtiene nuevo token con el refresh y valida si todo esta ok
            const res = await Vue.$http.post(options.refreshApi, { token: getAuthInfo().refreshToken }); // version sin cookies
            if (!res.data || !res.data.token) {
                return false;
            }

            // 3. actualiza la info del token 
            setAuthInfo(res.data);

            // 4. vuelve a configurar axios
            configureAxios();

            // 5. retorna todo ok
            return true;

        }

        // configuracion de axios, agregando los headers necesarios 
        // ---------------------------------------------------------

        function configureAxios() {

            // crea axios
            const http = axios.create({
                baseURL: options.baseApi,
                headers: {
                    Authorization: (getAuthInfo()) ? `Bearer ${getAuthInfo().token}` : '',
                }
            });

            // crea el interceptor: (redireccion a paginas de errores)
            const interceptor = http.interceptors.response.use(
                response => response,
                error => {
                    const { status } = error.response;
                    if (status == 401 || status == 403) { // UNAUTHORIZED 
                        // const refreshToken = getAuthInfo().refreshToken; // version sin cookies
                        http.interceptors.response.eject(interceptor);
                        // return http.post(options.refreshApi, { token: refreshToken }).then( // version sin cookies
                        return http.post(options.refreshApi).then( // version con cookies
                            res => {
                                setAuthInfo(res.data);
                                error.response.config.headers['Authorization'] = 'Bearer ' + res.data.token;
                                configureAxios();
                                return http(error.response.config);
                            }
                        ).catch(err => {
                            deleteAuthInfo();
                            options.router.push(options.loginRoute);
                        });
                    }
                    return Promise.reject(error);
                }
            );

            // lo asigna a la instancia
            Vue.$http = http;
        }

        // crea los metodos del servicio de AuthService 
        // ------------------------------------------------

        function configureAuthService() {
            const authService = {
                login: async function (credentials) {
                    try {
                        const res = await Vue.$http.post(options.loginApi, credentials);
                        setAuthInfo(res.data);
                        this.resetHttp();
                        // options.router.push(options.defaultRoute);
                        window.location.replace(options.base + options.defaultRoute);
                        return res.response;
                    } catch (e) {
                        throw e.response;
                    }
                },
                logout: async function () {
                    try {
                        const res = await Vue.$http.post(options.logoutApi);
                        deleteAuthInfo();
                        this.resetHttp();
                        window.location.replace(options.base + options.defaultRoute);
                        return res;
                    } catch (e) {
                        throw e.response;
                    }
                },
                isAuthenticated: function () {
                    if (getAuthInfo())
                        return true;
                    else
                        return false;
                },
                getUser: function () {

                },
                resetHttp: function () {
                    configureAxios();
                },

            };

            Vue.prototype.$auth = authService;
        }

        // configuracion
        configureAxios();
        configureRouter();
        configureAuthService();

    }
};

export default AuthService;
